// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Zg9lM","content":"Consent_content__2d-K9","footer":"Consent_footer__2roQ-"};